/**
 * Shared JWT HMAC secret for Edge middleware + app.
 * Fail-closed: no hardcoded fallback (prevents forged Super Admin cookies).
 */
export function getJwtSecret(): string {
  const secret = process.env.JWT_SECRET?.trim();
  if (!secret) {
    throw new Error(
      "JWT_SECRET is required. Set it in the environment to match cargogo-backend app.jwt.secret.",
    );
  }
  return secret;
}
